import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaCalendarAlt } from "react-icons/fa";
import logo from "../assets/elitecare-logo.png";
import { useAuth } from "../context/AuthContext";

export default function Navbar() {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentPath, setCurrentPath] = useState("/");

  useEffect(() => {
    const updatePath = () => {
      setCurrentPath(window.location.pathname);
    };

    updatePath();
    window.addEventListener("popstate", updatePath);

    return () => {
      window.removeEventListener("popstate", updatePath);
    };
  }, []);

  useEffect(() => {
    const closeMenuOnResize = () => {
      if (window.innerWidth > 900) {
        setMenuOpen(false);
      }
    };

    window.addEventListener("resize", closeMenuOnResize);

    return () => {
      window.removeEventListener("resize", closeMenuOnResize);
    };
  }, []);

  return (
    <>
      <style>
        {`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        body {
          overflow-x: hidden;
        }

        .navbar {
          width: 100%;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 60px;
          background: rgba(255, 255, 255, 0.96);
          border-bottom: 1px solid #e5e7eb;
          position: sticky;
          top: 0;
          z-index: 1000;
          backdrop-filter: blur(10px);
        }

        .logo-link {
          display: flex;
          align-items: center;
          text-decoration: none;
          z-index: 1002;
        }

        .logo-img {
          height: 55px;
          width: auto;
          object-fit: contain;
          display: block;
          mix-blend-mode: multiply; /* Blends JPEG background with navbar */
        }

        .nav-menu {
          display: flex;
          align-items: center;
          gap: 35px;
        }

        .nav-menu a {
          text-decoration: none;
          color: #374151;
          font-size: 16px;
          font-weight: 600;
          transition: all 0.3s ease;
          padding-bottom: 5px;
          border-bottom: 2px solid transparent;
        }

        .nav-menu a:hover {
          color: #22c55e;
        }

        .nav-menu a.active {
          color: #22c55e;
          border-bottom: 2px solid #22c55e;
        }

        .book-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #22c55e, #16a34a);
          color: white;
          border: none;
          padding: 12px 22px;
          border-radius: 25px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          box-shadow: 0 8px 18px rgba(34, 197, 94, 0.28);
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .book-btn:hover {
          transform: translateY(-2px);
          background: linear-gradient(135deg, #16a34a, #15803d);
        }

        .login-btn {
          display: flex;
          align-items: center;
          gap: 8px;
          background: transparent;
          color: #16a34a;
          border: 2px solid #16a34a;
          padding: 10px 22px;
          border-radius: 25px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .login-btn:hover {
          transform: translateY(-2px);
          background: #16a34a;
          color: white;
          box-shadow: 0 8px 18px rgba(22, 163, 74, 0.2);
        }

        .nav-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .menu-icon {
          display: none;
          font-size: 26px;
          cursor: pointer;
          color: #111827;
          user-select: none;
          z-index: 1002;
          width: 42px;
          height: 42px;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          transition: all 0.3s ease;
        }

        .menu-icon:hover {
          background: #f3f4f6;
        }

        .mobile-book-link {
          display: none;
        }

        @media (max-width: 900px) {
          .navbar {
            padding: 0 18px;
            height: 85px;
          }

          .logo-img {
            height: 45px;
          }

          .menu-icon {
            display: flex;
          }

          .book-btn, .login-btn {
            display: none;
          }

          .nav-menu {
            position: absolute;
            top: 85px;
            left: 0;
            width: 100%;
            background: rgba(255, 255, 255, 0.98);
            backdrop-filter: blur(12px);
            flex-direction: column;
            align-items: center;
            padding: 24px 20px 28px;
            gap: 22px;
            display: none;
            box-shadow: 0 14px 24px rgba(0, 0, 0, 0.06);
            border-top: 1px solid #f3f4f6;
          }

          .nav-menu.open {
            display: flex;
            animation: slideDown 0.25s ease;
          }

          .nav-menu a {
            font-size: 16px;
            padding-bottom: 4px;
          }

          .mobile-book-link {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            background: linear-gradient(135deg, #22c55e, #16a34a);
            color: white !important;
            padding: 12px 18px;
            border-radius: 22px;
            border-bottom: none !important;
            box-shadow: 0 8px 18px rgba(34, 197, 94, 0.22);
          }

          .mobile-book-link.active {
            color: white !important;
            border-bottom: none !important;
          }
        }

        @media (max-width: 480px) {
          .navbar {
            height: 80px;
            padding: 0 14px;
          }

          .logo-img {
            height: 40px;
          }

          .nav-menu {
            top: 80px;
            padding: 22px 16px 24px;
          }

          .nav-menu a {
            font-size: 15px;
          }

          .mobile-book-link {
            width: 100%;
            justify-content: center;
            max-width: 220px;
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        `}
      </style>

      <header className="navbar">
        <Link to="/" className="logo-link">
          <img src={logo} alt="Elite Care Logo" className="logo-img" />
        </Link>

        <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
          <Link
            to="/"
            className={currentPath === "/" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>

          <Link
            to="/services"
            className={currentPath === "/services" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            Services
          </Link>

          <Link
            to="/about"
            className={currentPath === "/about" ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            About Us
          </Link>

          {user && (
            <Link
              to="/admin-appointments"
              className={currentPath.startsWith("/admin") ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Dashboard
            </Link>
          )}

          <Link
            to="/book-appointment"
            className={`mobile-book-link ${currentPath === "/book-appointment" ? "active" : ""
              }`}
            onClick={() => setMenuOpen(false)}
          >
            <FaCalendarAlt />
            Book Appointment
          </Link>
        </nav>

        <div className="nav-actions">
          <Link to="/book-appointment" className="book-btn">
            <FaCalendarAlt />
            Book Appointment
          </Link>
          {!user && (
            <Link to="/admin/login" className="login-btn">
              Login
            </Link>
          )}
          <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "✕" : "☰"}
          </div>
        </div>
      </header>
    </>
  );
}